import { lazy } from "react";

const LoginPage = lazy(() => import(/* webpackChunkName: `LoginPage` */ `./LoginPage.js`));

//CUSTOMER
const CustomerUser = lazy(() => import( `./Customer/Users.js`));

//WALLET
const WalletStatistics = lazy(() => import(`./Wallet/Statistics.js`));
const WalletUsers = lazy(() => import(`./Wallet/Users.js`));
const WalletVouchers = lazy(() => import(`./Wallet/Vouchers.js`));
const WalletVouchersCampaign = lazy(() => import(`./Wallet/VouchersCampaign.js`));

//PaymentGateway
const TransactionsStatistics = lazy(() => import(`./PaymentGateway/StatisticsPG.js`));
const TransactionsDashboard = lazy(() => import(`./PaymentGateway/Transactions/TransactionsDashboard.js`));
const UploadPaymentContainer = lazy(() => import(`./PaymentGateway/Transactions/UploadPaymentContainer.js`));
const UploadCreditContainer = lazy(() => import(`./PaymentGateway/Transactions/UploadCreditContainer.js`));
const ReconciliationSearch = lazy(() => import(`./PaymentGateway/Reconciliation/ReconciliationSearch.js`));
const ReconciliationFile = lazy(() => import(`./PaymentGateway/Reconciliation/ReconciliationFile.js`));
const ReconciliationFailDay = lazy(() => import(`./PaymentGateway/Reconciliation/ReconciliationFailDay.js`));
const ScheduledPayments = lazy(() => import( `./PaymentGateway/ScheduledPayment.js`));

//SEPA
const PaymentHubStatistics = lazy(() => import(`./PaymentHub/SepaStatistics.js`));
const VoPcheck = lazy(() => import(`./PaymentHub/VoPcheck.js`));
const Sepa = lazy(() => import( `./PaymentHub/SDD/BulkSDD.js`));
const Bulk = lazy(() => import( `./PaymentHub/SDD/BulkSDD.js`));
const DebitSdd = lazy(() => import( `./PaymentHub/SDD/DebitSdd.js`));
const BulkSCT = lazy(() => import( `./PaymentHub/SCT/BulkSCT.js`));;
const Sct = lazy(() => import( `./PaymentHub/SCT/Sct.js`));
const DownloadSdd = lazy(() => import( `./PaymentHub/SDD/DownloadSDD.js`));
const DownloadSct = lazy(() => import( `./PaymentHub/SCT/DownloadSCT.js`));
const Mandate = lazy(() => import( `./PaymentHub/Mandate/Mandate.js`));
const CrossBorder = lazy(() => import( `./PaymentHub/CrossBorder/SCTCrossBorder.js`));

//BILLING
const BillingProduct = lazy(() => import( `./Billing/Products.js`));

//Config
const Config = lazy(() => import(/* webpackChunkName: `EmailSender` */ `./Config/Config.js`));
const AdminUsersDashboard = lazy(() => import(/* webpackChunkName: `UsersDashboard` */ `./Config/Users/UsersDashboard.js`));
const AdminUserCreate = lazy(() => import(/* webpackChunkName: `UsersCreate` */ `./Config/Users/UsersCreate.js`));

//Email sender
const EmailSender = lazy(() => import(/* webpackChunkName: `EmailSender` */ `./EmailSender/EmailDashboard.js`));
const EmailTemplate = lazy(() => import(/* webpackChunkName: `EmailSender` */ `./EmailSender/Template.js`));

//Commission
const CommissionsProductsDashboard = lazy(() => import(/* webpackChunkName: `CommissionsProductsDashboard` */ `./Commissions/CommissionsProductsDashboard.js`));
const CommissionsDashboard = lazy(() => import(/* webpackChunkName: `CommissionsDashboard` */ `./Commissions/CommissionsDashboard.js`));

//Reports
const ReportsDashboard = lazy(() => import(`./Reports/ReportsDashboard.js`));

export  { 
            LoginPage, AdminUsersDashboard,AdminUserCreate,UploadPaymentContainer,TransactionsStatistics,TransactionsDashboard,UploadCreditContainer,
            ReconciliationSearch,ReconciliationFile,EmailSender,EmailTemplate,Sct,VoPcheck,Sepa,Bulk,DebitSdd,DownloadSdd,Config,ReconciliationFailDay,
            BulkSCT,DownloadSct,Mandate,WalletStatistics,WalletUsers,WalletVouchers,WalletVouchersCampaign,PaymentHubStatistics,CustomerUser,BillingProduct,
            ScheduledPayments,CommissionsProductsDashboard,CommissionsDashboard,CrossBorder,ReportsDashboard
        };
